/**
 * Central brand configuration (frontend).
 * Keep in sync with config/brand.js on the server.
 */

export const BRAND = {
  name: 'Novrick',
  productName: 'Novrick',
  documentTitle: 'Novrick — Counterparty Assurance',
  descriptor: 'Counterparty Assurance',
  tagline: 'Know which counterparties are financially strong before exposure becomes risk.',
  shortTagline: 'Make confident supplier and counterparty decisions in minutes.',
  supportLine: 'Built for Procurement, Treasury, Finance, and Risk teams.',
  /** Confirm .com vs .ai at DNS time — change only here and in config/brand.js. */
  publicHost: 'novrick.com',
  canonicalHost: 'novrick.com',
  contactEmail: 'hello@novrick.com',
  copyrightYear: 2026,
  /** Legal entity line — Calyptor LLC retained only here. */
  legalCopyright: '© 2026 Calyptor LLC. Novrick is a product of Calyptor LLC.',
  assets: {
    faviconSvg: '/brand/favicon.svg',
    favicon32: '/brand/favicon-32.png',
    favicon180: '/brand/favicon-180.png',
    favicon512: '/brand/favicon-512.png',
    lockupDescriptorInk: '/brand/lockup-descriptor-ink.png',
    lockupHorizontalInk: '/brand/lockup-horizontal-ink.png',
    markSolid: '/brand/mark-solid.svg',
    markQuartered: '/brand/mark-quartered.svg',
    markBanded: {
      sound: '/brand/mark-banded-sound.svg',
      watch: '/brand/mark-banded-watch.svg',
      strained: '/brand/mark-banded-strained.svg',
      distressed: '/brand/mark-banded-distressed.svg'
    }
  }
};

export default BRAND;
